import { useContext } from 'react'
import history from '../../../../history'
import { defineMessages, useIntl } from 'react-intl'
import { Button } from '@homebot/shared-ui-swashbuckle'
import { PmiLearnMorePanel } from '../PmiLearnMorePanel'
import OverlayPanel from '../../../shared/Routing/OverlayPanel'
import { OVERLAY_HELPERS } from '../../../../constants/navigation'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'

export const MSG = defineMessages({
  tellMeMore: {
    id: 'Homeowner.mortgageInsurance.toggleMoreInfoButton',
    defaultMessage: 'Tell me more',
  },
})

export interface PmiLearnMoreButtonProps {
  flex?: string
}

export const PmiLearnMoreButton = ({ flex }: PmiLearnMoreButtonProps) => {
  const intl = useIntl()
  const { ampli } = useContext(AmplitudeContext)

  return (
    <>
      <OverlayPanel
        back={OVERLAY_HELPERS.pmiLearnMore.getOrigin()}
        path={OVERLAY_HELPERS.pmiLearnMore.buildPath()}
        title={OVERLAY_HELPERS.getTitle('pmiLearnMore', intl.formatMessage)}
        component={PmiLearnMorePanel}
      />
      <Button
        flex={flex}
        onClick={() => {
          ampli?.pmiInfoRequested()
          history.push(OVERLAY_HELPERS.pmiLearnMore.buildPath())
        }}
        data-qa='pmi-learn-more-cta'
      >
        {intl.formatMessage(MSG.tellMeMore)}
      </Button>
    </>
  )
}
